import { COUNTRY_SHORT_NAME } from '@commons/constants';
import {
  DECIDIR,
  SPREEDLY,
} from '@commons/utils/payment/paymentGatewayTypeConstants';

export const isCyberSourceRequired = function isCyberSourceRequired(
  gatewayType,
  country,
) {
  return (
    gatewayType === DECIDIR ||
    (gatewayType === SPREEDLY && country !== COUNTRY_SHORT_NAME.ARGENTINA)
  );
};

export default isCyberSourceRequired;
